document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('quoteForm');
  if (!form) return;

  form.addEventListener('submit', function () {
    var emailField = form.querySelector("input[name='contact[email]']");
    var userTypeField = document.getElementById('selected_project_type');
    var firstCatSelect = form.querySelector('select[data-role="cat"]');
    var qtyInputs = form.querySelectorAll('input[data-role="qty"]');

    var userEmail = emailField ? emailField.value.trim() : '';
    if (!userEmail) return;

    var userType = userTypeField ? userTypeField.value : 'Unknown';
    var primaryCategory =
      firstCatSelect && firstCatSelect.selectedIndex > -1
        ? firstCatSelect.options[firstCatSelect.selectedIndex].text
        : 'None';

    var totalQty = 0;
    qtyInputs.forEach(function (input) {
      var qty = parseInt(input.value, 10);
      if (!isNaN(qty)) totalQty += qty;
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'request_quote_submit',
      quote_category: primaryCategory,
      quote_total_qty: totalQty,
      userData: {
        email: userEmail,
        customerType: userType
      }
    });
  });
});